/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '@/utils/apiClient';

import {
  SignInIntroductionPayload,
  SignInIntroductionResponse,
  SignInIdentificationPayload,
  SignInIdentificationResponse,
  SignInConfirmationPayload,
  SignInConfirmationResponse,
} from './types';

/** Normalizes error messages from various API shapes */
function normalizeErr(err: any): string {
  const res: any = err?.response ?? err;

  if (Array.isArray(res?.error)) return res.error.join(' ');

  return (
    res?.detail || // catch Django/DRF-style "detail" errors
    res?.error || // API error arrays or strings
    res?.message || // APIs that return "message" (incl. Error.message from apiClient)
    (typeof res === 'string' ? res : '') ||
    'Unexpected error occurred'
  );
}

/** 1) SignIn Introduction */
export const postSignInIntroduction = createAsyncThunk<
  SignInIntroductionResponse,
  SignInIntroductionPayload,
  { rejectValue: string }
>('signin/postIntroduction', async (payload, { rejectWithValue }) => {
  try {
    const response = await apiClient('/auth/api/v1/signin/introduction/', {
      method: 'POST',
      body: payload,
    });
    return response as SignInIntroductionResponse;
  } catch (err: any) {
    return rejectWithValue(normalizeErr(err));
  }
});

/** 2) SignIn Identification */
export const postSignInIdentification = createAsyncThunk<
  SignInIdentificationResponse,
  SignInIdentificationPayload,
  { rejectValue: string }
>('signin/postIdentification', async (payload, { rejectWithValue }) => {
  try {
    const response = await apiClient('/auth/api/v1/signin/identification/', {
      method: 'POST',
      body: payload,
    });
    return response as SignInIdentificationResponse;
  } catch (err: any) {
    return rejectWithValue(normalizeErr(err));
  }
});

/** 3) SignIn Confirmation (OTP) */
export const postSignInConfirmation = createAsyncThunk<
  SignInConfirmationResponse,
  SignInConfirmationPayload,
  { rejectValue: string }
>('signin/postConfirmation', async (payload, { rejectWithValue }) => {
  try {
    const response = await apiClient('/auth/api/v1/signin/confirmation/', {
      method: 'POST',
      body: payload,
    });
    return response as SignInConfirmationResponse;
  } catch (err: any) {
    return rejectWithValue(normalizeErr(err));
  }
});
